import React, { useState, useContext, useEffect,useRef } from 'react';
import styled from 'styled-components';

import { ConfigurationContext,
         ContentContext } from '../../context';

import LabelCustom from './LabelCustom';
import InputCustom from './InputCustom';
import ButtonCustom from './ButtonCustom';
import SelectCustom from './SelectCustom';
import { FaPencilAlt, FaTimes } from "react-icons/fa";
import { TbPlaylistAdd } from "react-icons/tb";

import { TrashIcon,
         FilterAltIcon } from '../../helpers/icons';

import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip'



import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    //justify-content: space-between;
    //align-content: flex-end;
    width: 100%;
    
    background-color: ${props => `rgb(${props.panColors.light_white})`};
    box-sizing: border-box;
    .MuiSnackbar-root{
        position: absolute!important;
    }
    .products_list{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        width: 930px;
        padding: 0 30px 0 30px;
        margin-bottom: 15px;
        max-height: 200px;
        overflow-y: scroll;
        .product_item{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            background-color: #ccc;
            padding: 6px 6px;
            border-radius: 5px;
            margin-right: 5px;
            margin-bottom: 5px;
            //height: 40px;
            color: rgb(109, 105, 239);
            border: 1px solid rgb(109, 105, 239);
            background-color: rgba(109, 105, 239, 0.15);
            cursor: default;
            .bt_edit,
            .bt_delete{
                display: flex;
                font-size: 12px;
                line-height: 12px;
                margin-left: 5px;
                cursor: pointer;
                
            }
            .bt_edit{
                &:hover{
                    //color: ${props => `rgb(${props.panColors.middle_gray})`};
                    color: rgba(109, 105, 239, 0.5);
                }
            }
            .bt_delete{
                color: red;
                &:hover{
                    //color: ${props => `rgb(${props.panColors.middle_gray})`};
                    color: rgba(220, 46, 46, 0.5);
                }
            }
            p{
                padding: 0;
                margin: 0;
                font-size: 12px;
                line-height: 12px;
                font-weight: 500;
            }
        }

    }
    .product_select{
        width: ${props => props.is_edit ? '448px' : '540px'}; //550px;
        .select__control{
            margin-top: 5px;
            height: 43px!important;
            border: 1px solid rgb(186, 186, 194)!important;
        }
        .select__menu{
            
            .select__menu-list{
                max-height: 170px!important;
            }
        }
        &.error{
            .select__control{
                border: 2px solid rgb(220, 46, 46)!important;
                //border-color: rgb(220, 46, 46)!important;
            }
        }
    }
    .fields{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        width: calc(100% - 60px);
        padding: 15px 30px 25px 30px;
        .info_title,
        .info_text{
            width: calc(50% - 10px);
        }
        .field_min{
            //margin-right: 5px;
            width: 130px;
        }
        .field_max{
            //margin-right: 5px;
            width: 130px;
        }
        .field{
            &.product{
                //margin-right: 5px;
            }
        }
        >.actions{
            //style={{ width: props.is_edit ? "10px" : "30px" }};
            //width: 222px!important;
            width: ${props => props.is_edit ? '206px' : '102px'}; //550px;
            justify-content: flex-end!important;
        }
        .bt_add,
        .bt_cancel{
            min-height: 100%;
            box-sizing: border-box;
            padding: 0 20px 0 20px;
            border: 1px solid ${props => `rgb(${props.panColors.dots})`}!important;
            margin-left: 5px!important;
            background-color: ${props => `rgb(${props.panColors.dots})`};
            height: 42px!important;
            .text{
                color: #FFFFFF!important;
            }
            .icon{
                display: flex;
                font-size: 30px;
                margin-right: 0!important;
                color: ${props => `rgb(${props.panColors.dots})`};
            }
            &:hover{
                background-color: #FFFFFF;
                .text{
                    color: ${props => `rgb(${props.panColors.dots})`}!important;
                }
                .icon{
                    svg{
                        color: #FFFFFF!important;
                    }
                }
            }
        }
        .bt_cancel{
            //margin-left: 5px!important;
            border: 1px solid #FFFFFF!important;
            background-color: ${props => `rgb(${props.panColors.red})`};
            .text{
                color: #FFFFFF!important;
            }
            &:hover{
                border: 1px solid ${props => `rgb(${props.panColors.red})`}!important;
                background-color: #FFFFFF;
                .text{
                    color: ${props => `rgb(${props.panColors.red})`}!important;
                    
                }
            }
        }
        .bt_submit{
            min-height: 100%;
            box-sizing: border-box;
            padding: 0 15px 0 15px;
            .icon{
                margin-right: 0!important;
                svg{
                    width: 23px;
                    height: 23px;
                }
            }
        }
        /* .actions{
            box-sizing: border-box;
            min-height: 100%;
            //padding: 15px 15px 15px 0;
            .bt_submit{
                min-height: 100%;
                box-sizing: border-box;
                padding: 0 15px 0 15px;
                .icon{
                    margin-right: 0!important;
                    svg{
                        width: 23px;
                        height: 23px;
                    }
                }
            }
        } */
    }
    
    .select_categories,
    .select_subcategories{
        display: flex;
        flex-direction: column;
        padding: 25px 30px 0 30px;
        >.select{
            width: 100%;
            margin-top: 5px;
            .select__control{
                height: 43px!important;
                border: 1px solid rgb(186, 186, 194)!important;
            }
            .select__menu{
                
                .select__menu-list{
                    max-height: 170px!important;
                }
            }
        }
    }
    .select_subcategories{
        padding: 10px 30px 10px 30px;
    }
`

const AditionalInformationElement = (props) => {

    const { t } = useTranslation();
    
    const { panColors } = useContext(ConfigurationContext);
    const { ecommerceProducts,
            ecommerceCategories,
            getEcommerceProducts } = useContext(ContentContext);
    
    const { className,
            //index,
            //element,
            products,
            setProducts,
            options,
            setOptions,
            minGeneralSaved,
            maxGeneralSaved } = props;
    
    const formStyle = {background_color: `rgba(${panColors.white}, 1)`,
                       border_color: `rgba(${panColors.middle_gray}, 1)`};
    
    const isClearable = true;
    const isSearchable = true;
    const isDisabled = false;

    //const [isClearable, setIsClearable] = useState(true);
    //const [isSearchable, setIsSearchable] = useState(true);
    //const [isDisabled, setIsDisabled] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isRtl, setIsRtl] = useState(false);

    const [ max, setMax ] = useState(0);
    const [ min, setMin ] = useState(0);
    const [ fieldError, setFieldError ] = useState([]);
    const [ ecommerceCategoriesSelect, setEcommerceCategoriesSelect ] = useState([]);

    const [ category, setCategory ] = useState([]);
    const [ subcategory, setSubcategory ] = useState([]);
    const [ categoryError, setCategoryError ] = useState(null);
    const [ productError, setProductError ] = useState(null);
    
    const [ optionsSubcategories, setOptionsSubcategories ] = useState([]);
    const [ optionsProducts, setOptionsProducts ] = useState([]);
    const [ productSelected, setProductSelected ] = useState(null);
    const [ isEdit, setIsEdit ] = useState(false);


    const [ updateSuccess, setUpdateSuccess ] = useState(false);
    const [ haveResponseErrorMessage, setHaveResponseErrorMessage ] = useState("Los datos se han actualizaron correctamente");
    
    const handleClose = () => {
      setUpdateSuccess(false);
    }

    



    let timerDop = useRef();

    const handleInputChange = (e, val) => {
    }
    const handleOnKeyDown = (e, val) => {
        if(timerDop.current !== null){
            clearTimeout(timerDop.current);
        }
        timerDop.current = setTimeout(() => {
            const options_update = [...options];
            options_update.push({ value: 'xxx', label: 'Xxxxx', color: '#00875A' });
            setOptions(options_update);
        }, 3000);
    }

    const handleOnKeyUp = (val) => {
    }

    const handleCancelEdit = () => {
        setIsEdit(false);
        setMin("");
        setMax("");
        setProductSelected(null);
        setFieldError({min: false, max: false});
        setProductError(false);
        setCategoryError(null);
        setCategory("");
        setSubcategory("");
        //setOptionsProducts([]);
        //setOptionsSubcategories([]);
        //setProducts([]);
    }
    const handleAddElement = () => {
        //console.log("🐙", min, max, productSelected)
        let haveError = false;
        let fieldErrorUpdate = {min: false, max: false};
        if(!min){
            haveError = true;
            fieldErrorUpdate.min = true;
        }
        if(!max){
            haveError = true;
            fieldErrorUpdate.max = true;
        }
        if(!productSelected){
            setProductError(true);
        }else{
            setProductError(false);
        }
        setFieldError(fieldErrorUpdate);

        if(haveError){
            return null;
        }
        if(productSelected){
            if(productSelected.value === "all"){
                //console.log("OptionsProducts", optionsProducts)
                let temp = [];
                const updatedProducts = [...products];
                optionsProducts.forEach(item => {
                    if(item.value !== "all"){
                        const existingIndex = products.findIndex(p => p._id === item.value);
                        if (existingIndex === -1) {
                            temp.push({p_id: item.value, _id: item.value, min: min, max: max, label: item.label});
                        } else {
                            // Update min and max for the existing product
                            updatedProducts[existingIndex] = {
                                ...updatedProducts[existingIndex],
                                min: min,
                                max: max
                            };
                        }
                    }
                });
                //console.log("🐽", updatedProducts)
                //console.log("🐙", products, temp)
                setProducts([...updatedProducts, ...temp]);


                /*
                let temp = [];
                const optionsProductsUpdated = optionsProducts.map(item => {
                    if(item.value !== "all"){
                        if (!products.some(p => p._id === item.value)) {
                            temp.push({_id: item.value, min: min, max: max, label: item.label});
                        }else{

                            item.min = min;
                            item.max = max;
                            
                            //const index = products.findIndex(p => p._id === item.value);


                        }
                    }
                    return item;
                })
                console.log("🐽", optionsProductsUpdated)
                console.log("🐙", products, temp)
                setProducts([...products, ...temp]);
                */

                if(products?.length){
                    //setProducts([...products, temp]);
                }else{
                    //setProducts(temp);
                }
            }else{
                //console.log("XXXXXXXX")
                let products_update_object = {p_id: productSelected.value, _id: productSelected.value, min: min, max: max, label: productSelected.label};
                if (productSelected && !products.some(p => p._id === products_update_object._id)) {
                    setProducts([...products, products_update_object]);
                }else{
                    const index = products.findIndex(p => p._id === productSelected.value);
                    if (index !== -1) {
                        const updatedProducts = [...products];
                        updatedProducts[index] = {
                            ...updatedProducts[index],
                            min: min,
                            max: max,
                            label: productSelected.label
                        };
                        setProducts(updatedProducts);
                    }
                    //console.log("EXISTE")
                }
            }
        }

        if(isEdit){
            setUpdateSuccess(true);
        }
        //const elements = products.filter(el => el.id !== id);
        //setProducts(elements);
    }

    const handleRemoveElement = (id) => {
        const elements = products.filter(el => el.id !== id);
        setProducts(elements);
    }
    
    const handleRemoveProduct = (item) => {
        //console.log("🦞 handleRemoveProduct", item)
        setProducts(products.filter(p => p._id !== item._id));
    }

    const handleEditProduct = (item) => {
        //console.log("🦖 handleEditProduct", item)
        setIsEdit(true);
        findProductData(item._id);
        setMin(item.min);
        setMax(item.max);
    }

    const handleFormElementChange = (name, value) => {
        //console.log(name, value);
        
        const products_update = [...products];

        switch (name) {
            case 'min':
                setMin(value);
                //products_update[index].min = value;
                break;
            case 'max':
                setMax(value);
                //products_update[index].max = value;
                break;
            case 'category':
                setOptionsProducts([]);
                setProductSelected(null);
                setCategory(value);
                setSubcategory("");
                setMin("");
                setMax("");
                setProductError(false);
                setFieldError({min: false, max: false});
                if(value){
                    //console.log("😽ecommerceProducts:", ecommerceProducts);
                    //console.log("get", ecommerceCategories, value);
                    const subs = ecommerceCategories.filter((cat) => cat._id === value);
                    if(subs.length){
                        //console.log("🥳", subs[0]);
                        if(subs[0].categories.length){
                            setOptionsSubcategories(subs[0].categories);
                        }else{
                            let ids = [];
                            subs.forEach(sub => {
                                ids.push(category._id);
                            })
                            if(ids.length){
                                const filteredProducts = ecommerceProducts.filter(product => ids.includes(product.category_id));
                                //console.log("Filtered Products:", filteredProducts);
                            }

                        }
                        
                        /*
                        const extractIds = (categories) => {
                            let ids = [];
                            const traverse = (categories) => {
                                categories.forEach(category => {
                                    if (category._id) {
                                        ids.push(category._id);
                                    }
                                    if (category.categories && category.categories.length) {
                                        traverse(category.categories);
                                    }
                                });
                            };
                            traverse(categories);
                            return ids;
                        };

                        const allIds = extractIds(subs[0].categories);
                        console.log("Extracted IDs:", allIds);
                        console.log(ecommerceProducts);
                        const filteredProducts = ecommerceProducts.filter(product => allIds.includes(product.category_id));
                        if(filteredProducts.length){
                            getProducts(filteredProducts[0]);
                        }
                        console.log("Filtered Products:", filteredProducts);
                        */
                        
                    }else{
                        setOptionsSubcategories([]);

                        
                    }
                    //getProducts(value);
                }else{
                    setOptionsSubcategories([]);
                }
                break;
            case 'subcategory':
                setOptionsProducts([]);
                setProductSelected(null);
                setSubcategory(value);
                setMin("");
                setMax("");
                setProductError(false);
                setFieldError({min: false, max: false});
                getCategoriesProducts(value);
                break
            default:
                break;
        }

        setProducts(products_update);
        
        

    }

    const getCategoriesProducts = (value) => {

        if(value){
            const cats = ecommerceCategories.filter((cat) => cat._id === category);
            if(cats.length){
                const subs = cats[0].categories.filter((sub) => sub._id === value);
                if(subs.length){
                    //console.log("👉", subs[0]);

                    if(subs[0].categories.length){
                        const extractIds = (categories) => {
                            let ids = [];
                            const traverse = (categories) => {
                                categories.forEach(category => {
                                    if (category._id) {
                                        ids.push(category._id);
                                    }
                                    if (category.categories && category.categories.length) {
                                        traverse(category.categories);
                                    }
                                });
                            };
                            traverse(categories);
                            return ids;
                        };

                        const allIds = extractIds(subs[0].categories);
                        //console.log("Extracted IDs:", allIds);
                        
                    }else{

                        const filteredProducts = ecommerceProducts.filter(product => product.category_id === subs[0]._id);
                        getProducts(filteredProducts);
                        //console.log("😽Filtered Products:", filteredProducts);

                        /*
                        let ids = [];
                        subs.forEach(sub => {
                            ids.push(category._id);
                        })
                        if(ids.length){
                            const filteredProducts = ecommerceProducts.filter(product => ids.includes(product.category_id === subs[0]._id));
                            console.log("😽Filtered Products:", filteredProducts);
                        }
                        */
                    }

                }else{

                }
                
            }else{
                
            }
        }

    }

    const getProducts = (products) => {

        let options_arr = [];
        
        products?.length && products.map((product, index) => {
            if(product.name.length || product.ean.length){
                options_arr.push({label: `${product.name}${product.ean.length ? ' - ' + product.ean : ''}`, value: product._id});
            }
        })
        if(options_arr.length){
            options_arr.unshift({label: "Todos los productos", value: "all"});
        }
        setOptionsProducts(options_arr);

        /*
        console.log("😎", category);

        const payload = {
            'page': 0,
            'size': 1000,
            'category': "",//category,
            'date_order': -1,
            'text_filter': ""
        }
        const response = getEcommerceProducts(0, 1000, payload);

        response.then(res => {
            let options_arr = [];
            res?.data?.single?.products?.length && res.data.single.products.map((product, index) => {
                if(product.name.length || product.ean.length){
                    options_arr.push({label: `${product.name}${product.ean.length ? ' - ' + product.ean : ''}`, value: product._id});
                }
            })
            setOptionsProducts(options_arr);
        })
        */

    }

    const handleChange = (selectedOption) => {
        //console.log("selectedOption", selectedOption);  
        setProductSelected(selectedOption);
        const products_update = [...products];
        if(selectedOption){
            //products_update[index].p_id = selectedOption.value;
        }else{
            //products_update[index].p_id = '';
        }
        setProducts(products_update);
        
    }

    useEffect(() => {

        if(maxGeneralSaved.length && maxGeneralSaved.length){
            /*
            const products_update = [...products];
            products_update[index].min = minGeneralSaved;
            products_update[index].max = maxGeneralSaved;
            setProducts(products_update);
            */
        }

    return () => {}
    }, [])

    useEffect(() => {
      if(ecommerceCategories){
        setEcommerceCategoriesSelect();
      }
    
      return () => {}
    }, [ecommerceCategories])
    
    
    const getSelectedOption = () => {
        /*
        const elements = options.filter(option => option.value === products[index].p_id);
        console.log("options", options, elements[0]);
        return elements[0];
        */
    }

    const findProductData = (_id) => {

        const productFiltered = ecommerceProducts.filter(product => product._id === _id);
        if(productFiltered.length){
            const category_id = productFiltered[0].category_id;
            const productOnListFiltered = products.filter(product => product._id === _id);

            const path = findPathToCategory(ecommerceCategories, category_id);
            console.log("🐭", path, ecommerceCategories)
            setCategory(path[0]._id);
            setProductSelected({label: productOnListFiltered[0].label, value: productOnListFiltered[0]._id});
            setOptionsSubcategories(path[0].categories);
            if(path.length > 1){
                setSubcategory(path[1]._id);
                getCategoriesProducts(path[1]._id);
            }

            //console.log("Ruta encontrada:", path, [{label: productOnListFiltered.label, value: productOnListFiltered._id}], products, _id);
        }
        //console.log("🐤", productFiltered);
        //console.log("🐠", ecommerceProducts);
        //console.log("🦋", ecommerceCategories);

    }

    const findPathToCategory = (categories, targetId, path = []) => {
        console.log("🦊", categories)
        for (let cat of categories) {
            const newPath = [...path, cat];
            if (cat._id === targetId) {
                return newPath;
            }
            if (cat.categories && cat.categories.length) {
                const result = findPathToCategory(cat.categories, targetId, newPath);
                if (result) return result;
            }
        }
        return null;
    };

    useEffect(() => {
        //console.log("🐤", products.length, !firstLoad)
        if(products.length && firstLoad){
            console.log("🐤", products)

            const updatedProducts = products.map(item => {
                if (item.label === undefined || item.label === null) {
                    const found = ecommerceProducts.find(p => p._id === item._id);
                    if (found && found.name) {
                        return { ...item, label: found.name };
                    }
                }
                return item;
            });
        
            setProducts(updatedProducts);

            setFirstLoad(false);
        }
        /*
        const updatedProducts = products.map(item => {
            if (item.label === undefined || item.label === null) {
                const found = ecommerceProducts.find(p => p._id === item._id);
                if (found && found.name) {
                    return { ...item, label: found.name };
                }
            }
            return item;
        });
        */
        
        //setProducts(updatedProducts);
        /*
        if (JSON.stringify(updatedProducts) !== JSON.stringify(products)) {
            setProducts(updatedProducts);
        }
        */
      return () => {}
    }, [products])
    
    if(!options){
        return null;
    }
    
    return (
        <Wrapper
            className={className}
            panColors={panColors}
            is_edit={isEdit}
        >

            <Snackbar 
                open={updateSuccess} 
                autoHideDuration={2000} 
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                    {haveResponseErrorMessage}
                </Alert>
            </Snackbar>

            <div className="select_categories">
                <LabelCustom 
                    name="label_product"
                    label={t("texts.Categorias")}
                    onChange={handleFormElementChange}
                    className="field field_product"
                    styles={ formStyle }
                    label_icon={null}
                />
                <SelectCustom 
                    name={"category"}
                    label={null}
                    placeholder={t("texts.Seleccionar categoria") + "..."}
                    onChange={handleFormElementChange}
                    className={`select field field_category${categoryError === 0 ? " error" : ""}`}
                    type="text"
                    value={category}
                    help={null}
                    isRequired={false}
                    styles={ formStyle }
                    label_icon={null}
                    tooltip_content={null}
                    haveError={categoryError === 0 ? true : false}
                    data={ecommerceCategories}
                    disabled={isEdit ? true : false}
                />
            </div>

            {optionsSubcategories.length ?
                <div className="select_subcategories">
                    <LabelCustom 
                        name="label_product"
                        label={t("texts.Subcategorias")}
                        onChange={handleFormElementChange}
                        className="field field_product"
                        styles={ formStyle }
                        label_icon={null}
                    />
                    <SelectCustom 
                        name={"subcategory"}
                        label={null}
                        placeholder={t("texts.Seleccionar subcategoria") + "..."}
                        onChange={handleFormElementChange}
                        className={`select field field_category${categoryError === 0 ? " error" : ""}`}
                        type="text"
                        value={subcategory}
                        help={null}
                        isRequired={false}
                        styles={ formStyle }
                        label_icon={null}
                        tooltip_content={null}
                        haveError={categoryError === 0 ? true : false}
                        data={optionsSubcategories}
                        disabled={isEdit ? true : false}
                    />
                </div> 
            : "" }

            <div className="fields">
                <div className='field product'>
                    <LabelCustom 
                        name="label_product"
                        label={t("texts.Producto")}
                        onChange={handleFormElementChange}
                        className="field field_product"
                        styles={ formStyle }
                        label_icon={null}
                    />
                    <Select
                        className={`product_select${productError ? " error" : ""}`}
                        //className="product_select"
                        classNamePrefix="select"
                        value={productSelected}
                        //defaultValue={productSelected/*getSelectedOption()*/}
                        //isDisabled={isDisabled}
                        isDisabled={isEdit ? true : false}
                        isLoading={isLoading}
                        isClearable={isClearable}
                        isRtl={isRtl}
                        isSearchable={isSearchable}
                        name="color"
                        options={optionsProducts/*options*/}
                        onInputChange={handleInputChange}
                        onKeyDown={handleOnKeyDown}
                        onKeyUp={handleOnKeyUp}
                        onChange={handleChange}
                        placeholder={t("texts.Buscar por nombre o código EAN") + "..."}
                    />
                </div>
                
                <InputCustom 
                    name={"min"}
                    label={t("texts.Minimo")}
                    placeholder={t("texts.Ingresar link") + "..."}
                    onChange={handleFormElementChange}
                    onKeyDown={null}
                    className={`field field_min ${fieldError['min'] ? " error" : ""}`}
                    type="text"
                    value={min/*products[index].min*/}
                    help={""}
                    isRequired={false}
                    styles={ formStyle }
                    label_icon={null}
                    tooltip_content={null}
                    haveError={fieldError['min'] ? true : false}
                />

                <InputCustom 
                    name={"max"}
                    label={t("texts.Maximo")}
                    placeholder={t("texts.Ingresar link") + "..."}
                    onChange={handleFormElementChange}
                    onKeyDown={null}
                    className={`field field_max ${fieldError['max'] ? " error" : ""}`}
                    type="text"
                    value={max/*products[index].max*/}
                    help={""}
                    isRequired={false}
                    styles={ formStyle }
                    label_icon={null}
                    tooltip_content={null}
                    haveError={fieldError['max'] ? true : false}
                />

                <div className='actions'>
                    <ButtonCustom 
                        className="bt_add"
                        text={`${isEdit ? 'Editar' : "Agregar"}`}
                        onClick={() => handleAddElement(/*element.id*/)}
                        style_type="normal"
                        
                        icon={""}
                        background={{ normal: panColors.white, hover: panColors.white }}
                        border={{ normal: panColors.red, hover: panColors.primary }}
                        textcolor={{ normal: panColors.red, hover: panColors.primary }}
                    />
                    {isEdit ?
                    <ButtonCustom 
                        className="bt_cancel"
                        text="Cancelar"
                        onClick={() => handleCancelEdit(/*element.id*/)}
                        style_type="normal"
                        
                        icon={""}
                        background={{ normal: panColors.white, hover: panColors.white }}
                        border={{ normal: panColors.red, hover: panColors.primary }}
                        textcolor={{ normal: panColors.red, hover: panColors.primary }}
                    /> : ""}
                </div>

                {/* <ButtonCustom 
                    className="bt_submit"
                    text=""
                    onClick={() => handleRemoveElement()}
                    //onClick={() => handleRemoveElement(element.id)}
                    style_type="normal"
                    
                    icon={<TrashIcon />}
                    background={{ normal: panColors.white, hover: panColors.white }}
                    border={{ normal: panColors.red, hover: panColors.primary }}
                    textcolor={{ normal: panColors.red, hover: panColors.primary }}
                /> */}

                {/* <div className='actions'>
                    <ButtonCustom 
                        className="bt_submit"
                        text=""
                        onClick={() => handleRemoveElement(element.id)}
                        style_type="normal"
                        
                        icon={<TrashIcon />}
                        background={{ normal: panColors.white, hover: panColors.white }}
                        border={{ normal: panColors.red, hover: panColors.primary }}
                        textcolor={{ normal: panColors.red, hover: panColors.primary }}
                    />
                </div> */}
            </div>

            <Tooltip 
                id="my-tooltip" 
                className='tooltip'
            />

            <div className='products_list'>

                {
                    products.map((item, i) => {
                        return(
                            <div 
                                className='product_item'
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={`Mínimo: ${item.min} | Máximo: ${item.max}`}
                                data-tooltip-place="top"
                                data-tooltip-offset={7}
                            >
                                <p>{item.label}</p>
                                <div 
                                    className='bt_edit'
                                    onClick={() => { handleEditProduct(item)}}
                                >
                                    <FaPencilAlt />
                                </div>
                                <div 
                                    className='bt_delete'
                                    onClick={() => { handleRemoveProduct(item)}}
                                >
                                    <FaTimes />
                                </div>
                            </div>
                        )
                    })
                }
                
            </div>

        </Wrapper>

    )

}

export default AditionalInformationElement;